import { FC } from 'react'
import cx from 'classnames'

import { MediaListProps } from '../MediaList'
import { ActionButtonProps } from '../ActionButton'
import { ActionButtonVariant } from '../ActionButton/styled'

import * as SC from './styled'

export type AdsMediaGalleryProps = {
  className?: string
  title?: string
  mediaList: MediaListProps
  seeMoreButton?: ActionButtonProps
}

const AdsMediaGallery: FC<AdsMediaGalleryProps> = ({
  className,
  title,
  mediaList,
  seeMoreButton,
}) => {
  return (
    <SC.Container
      className={cx('AdsMediaGallery', className)}
      withBackgroundColor
      maxWidth="Xsmall"
    >
      <SC.Title>{title}</SC.Title>
      <SC.Medias {...mediaList} />
      {seeMoreButton && (
        <SC.SeeMore
          {...seeMoreButton}
          variant={ActionButtonVariant.quaternary}
        />
      )}
    </SC.Container>
  )
}

export default AdsMediaGallery
